const texts = {
  header: {
    search: 'Buscador'
  },
  menu: {
    welcome: 'Bienvenid@',
    quizParticles: 'Quiz Partículas',
    insertParticle: 'Insertar particula',
    globalReview: 'Repaso Global',
    search: 'Buscador'
  },
  card: {
    // listen: 'Escuchar',
    correct: '○ Acerté',
    incorrect: '× Fallé'
  },
  custom: {
    title: 'Flashcards Personalizadas',
    generate: 'Generar Flashcards',
    results: 'Resultados',
    restart: 'Reiniciar'
  },
  flip: {
    verResults: 'Ver resultados',
    reiniciar: 'Reiniciar',
    resultados: 'Resultados'
  },
  search: {
    title: 'Buscador de vocabulario',
    placeholder: 'Buscar por castellano, hiragana, kanji o categoría...'
  },
  dragdrop: {
    title: 'Insertar particula',
    completeMissing: 'Completa todos los huecos antes de validar.',
    correct: '○ ¡Correcto!'
  }
}

export default texts
